  
  <nav class="navbar navbar-expand-lg navbar-light pt-0 pb-0">
    <div class="container">
        <div class="res-disp-flex res-w-100 justify-content-between">
            <a class="navbar-brand pt-0" routerLink="/">
                <img src="../assets/images/logos/Strait_Air_SPOT.png" alt="logo" class="logo-img">
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
               <span class="navbar-toggler-icon"></span>
            </button>
        </div>
  
        <div class="bs-navbar-collapse collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto">
                <li class="nav-item" >
                    <a class="nav-link" [routerLinkActive]="['active']" routerLink="about" data-toggle="collapse" data-target=".navbar-collapse.show">About</a>
                    <!-- <a class="nav-link" routerLink="main-footer">About</a> -->
                </li>
                
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Services
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" [routerLinkActive]="['active']" routerLink="air-service" data-toggle="collapse" data-target=".navbar-collapse.show">Air Services</a>
                        <a class="dropdown-item" [routerLinkActive]="['active']" routerLink="ocean-service" data-toggle="collapse" data-target=".navbar-collapse.show">Ocean Services</a>
                        <a class="dropdown-item" [routerLinkActive]="['active']" routerLink="verticals" data-toggle="collapse" data-target=".navbar-collapse.show">Verticals</a>
                        <a class="dropdown-item" [routerLinkActive]="['active']" routerLink="value-added-service" data-toggle="collapse" data-target=".navbar-collapse.show">Value Added Services</a>
                    </div>
                </li>
        
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" [routerLinkActive]="['active']" routerLink="apps" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Apps
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" [routerLinkActive]="['active']" routerLink="container-specification" data-toggle="collapse" data-target=".navbar-collapse.show">Container Specification</a>
                        <a class="dropdown-item" [routerLinkActive]="['active']" routerLink="emission-calculator" data-toggle="collapse" data-target=".navbar-collapse.show">Emission Calculator</a>
                        <a class="dropdown-item" [routerLinkActive]="['active']" routerLink="freight-volume-calculator" data-toggle="collapse" data-target=".navbar-collapse.show">Freight Volume Calculator</a>
                        <a class="dropdown-item" [routerLinkActive]="['active']" routerLink="container-vessel-tracker" data-toggle="collapse" data-target=".navbar-collapse.show">Container Vessel Tracker</a>
                        <a class="dropdown-item" [routerLinkActive]="['active']" routerLink="inco-terms" data-toggle="collapse" data-target=".navbar-collapse.show">INCO Terms</a>
                        <a class="dropdown-item" [routerLinkActive]="['active']" routerLink="shipping-glossary" data-toggle="collapse" data-target=".navbar-collapse.show">Shipping Glossary</a>
                    </div>
                </li>
                <li class="nav-item">
                    <div data-toggle="collapse" data-target=".navbar-collapse.show">
                            <a href="/#latest-news" class="nav-link">News</a>
                    </div>
                </li>
                <li class="nav-item" routerLink="contact">
                    <a class="nav-link" [routerLinkActive]="['active']" data-toggle="collapse" data-target=".navbar-collapse.show">Contact</a>
                </li>
                <li>
                    <a routerLink="/" data-toggle="collapse" data-target=".navbar-collapse.show"><i class="fa fa-home" aria-hidden="true"></i></a>
                </li>
                
            </ul>
        </div>
        <!-- <div class="">
            <i class="fa fa-home" aria-hidden="true"></i>
        </div> -->
  </div>
  </nav>
